<template>
  <a class="button" :href="url" :target="{target}">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: String,
    url: String,
    target: {
      type: String,
      default: '_self'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
  display: inline-block;
  padding: 0 2.4rem;
  background: var(--novasell-green);
  font-size: var(--small-font-size);
  line-height: 3.42857142857;
  color: var(--white);
  font-weight: var(--bold-font-weight);
  border-radius: 1.2rem;
  box-shadow: 0 0.8rem 2.4rem 0 rgba(0,0,0,0.2);
  transition: 0.5s;
}

a:hover {
  background: var(--dark-green);
  box-shadow: 0 0.2rem 2rem 0 rgba(0,170,20,0.4);
  transition: 0.1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/Button.vue